import React from "react";
import "../../../styles/customize-components/page-heading.css";
import { ReloadIcon } from "../../../images/icons/icons";
import { FilterIcon } from "../../../images/icons/icons";

const PageHeadingNew = ({
  heading,
  subheading,
  buttonLabel,
  onButtonClick,
  buttonLabel1,
  onButtonClick1,
  onReload,
  showFilters,
  setShowFilters,
  hasFiltersApplied = false,
  btnClassname = "",
}) => {
  return (
    <div className="page-heading-container">
      <div className="page-heading-left">
        <h1 className="page-heading-title">
          {heading}{" "}
          {onReload && (
            <button
              className="page-heading-reload-btn"
              onClick={onReload}
              title="Reload"
              type="button"
            >
              <ReloadIcon />
            </button>
          )}
        </h1>

        {subheading && (
          <div className="page-heading-subheading">{subheading}</div>
        )}
      </div>
      <div className="page-heading-right">
        {showFilters !== undefined && (
          <div
            className={`filter-toggle-container ${hasFiltersApplied ? 'filters-applied' : ''}`}
            onClick={() => setShowFilters(!showFilters)}
            title={showFilters ? "Hide Filters" : "Show Filters"}
          >
            <button className={`page-heading-filter-toggle-btn`}>
              <FilterIcon />
            </button>
            <span className={`page-heading-filter-toggle-label`}>
              {showFilters ? "Hide Filters" : "Show Filters"}
            </span>
          </div>
        )}
        
        {buttonLabel && (
          <button
            className={`page-heading-btn ${btnClassname}`}
            onClick={onButtonClick}
          >
            <span className="page-heading-btn-icon">+</span> {buttonLabel}
          </button>
        )}

        {buttonLabel1 && (
          <button
            className={`page-heading-btn page-heading-btn-1 ${btnClassname}`}
            onClick={onButtonClick1}
          >
            {buttonLabel1}
          </button>
        )}
      </div>
    </div>
  );
};

export default PageHeadingNew;